import { render, staticRenderFns } from "./CustomFieldExample.vue?vue&type=template&id=1d54aa2e"
import script from "./CustomFieldExample.vue?vue&type=script&lang=js"
export * from "./CustomFieldExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports